import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translation } from "react-i18next";

import { PUBLIC_SITE_URL } from 'utils/restapi';
import { cutHTTP } from 'utils/fixURL';

import Copy from 'components/elements/buttons/Copy';
import FixedNotification from 'components/common/FixedNotification';

import './CustomDomainDetails.css';
import CommonMessage from "components/common/CommonMessage";

const CustomDomainDetails = ({
  me,
}) => {

  const [showTxtNameNotification, setTxtNameNotification] = useState(false);
  const [showTxtValueNotification, setTxtValueNotification] = useState(false);
  const [showCnameNameNotification, setCnameNameNotification] = useState(false);
  const [showCnameValueNotification, setCnameValueNotification] = useState(false);

  if (!me || (me && !me.custom_domain) || (me && me.custom_domain.is_verified)) {
    return null;
  }

  const { custom_domain, username } = me;

  const txtData = {
    name: `verify.${custom_domain.domain}`,
    value: `heylinkme-verification-code=${custom_domain.verification_code}`
  };
  const cnameData = {
    name: custom_domain.domain,
    value: `${username}.${cutHTTP(PUBLIC_SITE_URL)}`,
  };

  const renderNotifications = () => {
    if (showTxtNameNotification) {
      return (
        <Translation>
          {(t) => (
            <FixedNotification
              onFadeComplete={() => {
                setTxtNameNotification(false);
              }}
            >
              {t("TXT name has been copied: paste it anywhere!")}
            </FixedNotification>
          )}
        </Translation>
      );
    }
    if (showTxtValueNotification) {
      return (
        <Translation>
          {(t) => (
            <FixedNotification
              onFadeComplete={() => {
                setTxtValueNotification(false);
              }}
            >
              {t("TXT value has been copied: paste it anywhere!")}
            </FixedNotification>
          )}
        </Translation>
      );
    }
    if (showCnameNameNotification) {
      return (
        <Translation>
          {(t) => (
            <FixedNotification
              onFadeComplete={() => {
                setCnameNameNotification(false);
              }}
            >
              {t("CNAME name has been copied: paste it anywhere!")}
            </FixedNotification>
          )}
        </Translation>
      );
    }
    if (showCnameValueNotification) {
      return (
        <Translation>
          {(t) => (
            <FixedNotification
              onFadeComplete={() => {
                setCnameValueNotification(false);
              }}
            >
              {t("CNAME value has been copied: paste it anywhere!")}
            </FixedNotification>
          )}
        </Translation>
      );
    }
    return null;
  };

  return (
    <Translation>
      {(t) => (
        <div className="custom-domain-details__component">
          <div className="custom-domain-details-wrapper">
            <p>
              {t("Please copy and add CNAME and TXT configuration to your domain’s DNS records " +
                 "(typically you can do it by logging in to Domain.com, GoDaddy, Namecheap, HostGator, DreamHost etc). " +
                 "Once added please click")} <b>&lsquo;{t("Verify")}&rsquo;</b>
            </p>
    
            {/* TYPE TXT */}
            <div className="custom-domain-details-section txt">
              <h4>{t("type txt")}</h4>
              <div className="fields-section-wrapper">
                <div className="fields-section-content">
                  <div className="pseudo-field">
                    <span>{t("Name")}</span>
    
                    <div className="pseudo-field-input">
                      <div className="content">{txtData.name}</div>
                      <div className="copy-btn">
                        <Copy
                          noIcon
                          className="custom-domain-details-copy-btn"
                          copyText={txtData.name}
                          onCopy={() => {
                            setTxtNameNotification(true);
                          }}
                          btnText={t("Copy")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="pseudo-field">
                    <span>{t("Value")}</span>
    
                    <div className="pseudo-field-input">
                      <div className="content">{txtData.value}</div>
    
                      <div className="copy-btn">
                        <Copy
                          noIcon
                          className="custom-domain-details-copy-btn"
                          copyText={txtData.value}
                          onCopy={() => {
                            setTxtValueNotification(true);
                          }}
                          btnText={t("Copy")}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
    
            {/* TYPE CNAME */}
            <div className="custom-domain-details-section cname">
              <h4>{t("type cname")}</h4>
              <div className="fields-section-wrapper">
                <div className="fields-section-content">
                  <div className="pseudo-field">
                    <span>{t("Name")}</span>
    
                    <div className="pseudo-field-input">
                      <div className="content">{cnameData.name}</div>
    
                      <div className="copy-btn">
                        <Copy
                          noIcon
                          className="custom-domain-details-copy-btn"
                          copyText={cnameData.name}
                          onCopy={() => {
                            setCnameNameNotification(true);
                          }}
                          btnText={t("Copy")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="pseudo-field">
                    <span>{t("Value")}</span>
    
                    <div className="pseudo-field-input">
                      <div className="content">{cnameData.value}</div>
    
                      <div className="copy-btn">
                        <Copy
                          noIcon
                          className="custom-domain-details-copy-btn"
                          copyText={cnameData.value}
                          onCopy={() => {
                            setCnameValueNotification(true);
                          }}
                          btnText={t("Copy")}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
    
          <CommonMessage info>
            {t("Please check for more information")} <a href="https://blog.heylink.me/2020/10/15/how-to-add-custom-domain-white-label-on-heylink-me-in-2020/" target="_blank">{t("Custom Domain FAQ Guide")}</a>
          </CommonMessage>
    
          <CommonMessage info>
            {t("Please keep in mind that it takes 12-36 hours to update your HeyLink.me to a " +
              "custom domain once you enter the domain configuration details.")}
          </CommonMessage>
    
          {renderNotifications()}
        </div>
      )}
    </Translation>
  );
};

CustomDomainDetails.propTypes = {
  me: PropTypes.object,
};
CustomDomainDetails.defaultProps = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
)(CustomDomainDetails);
